import axios, {AxiosInstance} from 'axios'
import bofhDefaultHeaders from '../bofhDefaultHeaders'
import setProfileKey from 'utils/setProfileKey'
import setHttpRequestId from 'utils/setHttpRequestId'

import bofhApiUrl from '../bofhApiUrl'

import {BOOKING_REQUEST_ID_HEADER} from '@daedalus/core/src/booking/services/bookApi'
import {LinkType} from '@daedalus/core/src/booking/types/Link'
import {
  BookingFinalizationRequest,
  BookingRequestWithPsd2
} from '@daedalus/core/src/booking/types/BookingRequest'
import {BookingCreationResponse} from '@daedalus/core/src/booking/types/BookingCreationResponse'
import {BookingFinalizationResponse} from '@daedalus/core/src/booking/types/BookingFinalizationResponse'

const axiosConfig = {
  headers: bofhDefaultHeaders
}

const axiosInstance = axios.create(axiosConfig)

const getBookFinalizationFactory =
  (httpService: AxiosInstance) =>
  async (
    link: LinkType,
    params: BookingFinalizationRequest,
    profile: string,
    httpRequestId: string,
    bookingRequestId: string
  ) => {
    httpService.defaults.headers.common['X-Api-Key'] = profile
    setHttpRequestId(httpService, httpRequestId)
    const requestURL = link.href
    const headers = {
      [BOOKING_REQUEST_ID_HEADER]: bookingRequestId
    }
    return httpService.put<BookingFinalizationResponse>(requestURL, params, {
      headers
    })
  }

export const getFetchBookingFactory =
  httpService => (params, experimentApiKey) => {
    setProfileKey(httpService, experimentApiKey)

    const {locale, deviceType, bookingId} = params

    return httpService.get(bofhApiUrl(`bookings/${bookingId}/`), {
      params: {locale, deviceType}
    })
  }

const getCreateBookingFactory =
  (httpService: AxiosInstance) =>
  async (
    link: LinkType,
    params: BookingRequestWithPsd2,
    profile: string,
    httpRequestId: string,
    bookingRequestId: string
  ) => {
    httpService.defaults.headers.common['X-Api-Key'] = profile
    setHttpRequestId(httpService, httpRequestId)
    const requestURL = link.href
    const headers = {
      [BOOKING_REQUEST_ID_HEADER]: bookingRequestId
    }
    return httpService.post<BookingCreationResponse>(requestURL, params, {
      headers
    })
  }

const getCreateBookingService = getCreateBookingFactory(axiosInstance)

const fetchBookingService = getFetchBookingFactory(axiosInstance)

const bookOfferFinalizationService = getBookFinalizationFactory(axiosInstance)

export {
  fetchBookingService,
  bookOfferFinalizationService,
  getCreateBookingService
}
